module.exports = __webpack_public_path__ + "img/LicensesAndActivationsTableRetrieveActivation.b3352579.png";